import { useQuery } from '@tanstack/react-query';
import { withholdingsQueryKey } from './keys';
import { normalizeWithholding, sortWithholdings } from '../types';
import type { WithholdingDto, WithholdingsHttpRequest, RawWithholdingDto } from '../types';

export interface UseWithholdingsParams {
  documentId: string;
  /**
   * Endpoint GET de la lista TF3 (BRECHA G1/GAP-1). Si se omite, la query queda
   * deshabilitada y la grilla se puebla solo con `initialData` / mutaciones.
   */
  withholdingsEndpoint?: string;
  httpRequest: WithholdingsHttpRequest;
  /** Datos iniciales (p.ej. provenientes de la sección FactBox del adapter). */
  initialData?: WithholdingDto[];
  enabled?: boolean;
}

/**
 * Carga la lista de retenciones (TF3) del documento (lo que la grilla renderiza).
 *
 * Cache key: `['document-withholdings', documentId]`. Normaliza cada fila y
 * aplica el orden canónico (manuales → manipuladas → automáticas).
 */
export function useWithholdings({
  documentId,
  withholdingsEndpoint,
  httpRequest,
  initialData,
  enabled = true,
}: UseWithholdingsParams) {
  return useQuery<WithholdingDto[]>({
    queryKey: withholdingsQueryKey(documentId),
    enabled: enabled && Boolean(documentId) && Boolean(withholdingsEndpoint),
    initialData: initialData ? sortWithholdings(initialData) : undefined,
    queryFn: async () => {
      const raw = await httpRequest<RawWithholdingDto[]>('GET', withholdingsEndpoint!);
      return sortWithholdings((raw ?? []).map(normalizeWithholding));
    },
  });
}
